export const CUSTOMER_AGENT_FEEDBACK_MESSAGE = 'CUSTOMER_AGENT_FEEDBACK';
export const POSITIVE = 'POSITIVE';
export const NEGATIVE = 'NEGATIVE';
export const REDACT_POSITIVE = 'REDACT_POSITIVE';
export const REDACT_NEGATIVE = 'REDACT_NEGATIVE';